module.exports = __webpack_public_path__ + "img/love.cd41e2f7.png";